import React from "react";
import { Card } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.min.css";
// import logo from "../../../images/Logo.png";

const ProgressTracker = ({ missedLectures, totalLectures, attendance }) => {

  return (
    <Card className="text-dark p-0 position-relative shadow-sm mt-4 border rounded-3"
    style={{
      backgroundImage: `url("https://img.freepik.com/premium-vector/abstract-technology-ui-futuristic-hud-interface_36402-348.jpg?semt=ais_hybrid")`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    }}>
      {/* Logo at Top Right */}

      <Card.Body className="text-center">
        <h2 className="mb-4 text-white">Hey XYZ, let's track your progress...</h2>

        {/* Progress Bar */}
        <div className="progress mb-4 bg-light position-relative" style={{ height: "8px" }}>
          <div className="progress-bar" role="progressbar" style={{ width: `${75}%` }}></div>
        </div>

        {/* Metrics Grid */}
        <div className="row g-3">
          {/* Missed Lectures */}
          <div className="col-12 col-md-4">
            <Card className="bg-light text-dark p-2 border border-dark hover-effect">
              <Card.Body className="d-flex justify-content-center align-items-center p-3">
                <span className="fs-3 fw-bold text-dark mr-4">{4}</span>
                <span className="d-flex align-items-center">
                  <i className="bi bi-person-x-fill fs-1 text-danger" style={{ lineHeight: 1, height: "auto" }}></i>
                </span>
              </Card.Body>
              <Card.Footer className="text-center fs-5 fw-bold">Missed Lectures</Card.Footer>
            </Card>
          </div>

          {/* Total Lectures */}
          <div className="col-12 col-md-4">
            <Card className="bg-light text-dark p-0 border border-dark hover-effect">
              <Card.Body className="d-flex justify-content-center align-items-center p-3">
                <span className="fs-3 fw-bold text-dark mr-4">{25}</span>
                <span className="d-flex align-items-center">
                  <i className="bi bi-book-fill fs-1 text-primary" style={{ lineHeight: 1, height: "auto" }}></i>
                </span>
              </Card.Body>
              <Card.Footer className="text-center fs-5 fw-bold">Total Lectures</Card.Footer>
            </Card>
          </div>

          {/* Total Attendance */}
          <div className="col-12 col-md-4">
            <Card className="bg-light text-dark p-0 border border-dark hover-effect">
              <Card.Body className="d-flex justify-content-center align-items-center p-3">
                <span className="fs-3 fw-bold text-dark mr-4">{75}</span>
                <span className="fs-3">/100</span>
              </Card.Body>
              <Card.Footer className="text-center fs-5 fw-bold">Total Attendance</Card.Footer>
            </Card>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ProgressTracker;
